var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _assertThisInitialized = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits.js");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
module.exports = function (e) {
  var t = {};
  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
      return e[t];
    }.bind(null, o));
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "default", function () {
    return i;
  });
  var r = n(0),
    o = n.n(r);
  var i = /*#__PURE__*/function (_o$a$Component) {
    function i(e) {
      var _this;
      _classCallCheck(this, i);
      _this = _callSuper(this, i, [e]), _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
      return _this;
    }
    _inherits(i, _o$a$Component);
    return _createClass(i, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener("click", this.handleClick, !1);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener("click", this.handleClick, !1);
      }
    }, {
      key: "handleClick",
      value: function handleClick(e) {
        this.refs.child_0.contains(e.target) || this.props.handler(e);
      }
    }, {
      key: "render",
      value: function render() {
        return o.a.Children.map(this.props.children, function (e, t) {
          return o.a.cloneElement(e, {
            ref: "child_" + t
          });
        });
      }
    }]);
  }(o.a.Component);
  i.defaultProps = {
    handler: function handler() {}
  };
}]);